import React from 'react';

import { LayoutBackgroundColor } from '@/payload-types';
import { cn } from '@/utils/cn';

import styles from './BlockSettings.module.scss';

type BlockSettings = {
  children: React.ReactNode;
  backgroundColor?: LayoutBackgroundColor | 'none';
  spacing?: 'none' | 'small' | 'medium' | 'large' | null;
  individualSpacing?: boolean | null;
  spacingBottom?: 'none' | 'small' | 'medium' | 'large' | null;
  spacingTop?: 'none' | 'small' | 'medium' | 'large' | 'top' | null;
};

const invertedThemes = ['indigo-800', 'indigo-500', 'mint-800'];

export const BlockSettings: React.FC<BlockSettings> = (props) => {
  const {
    backgroundColor = 'white',
    individualSpacing = false,
    spacing = 'small',
    spacingBottom = 'small',
    spacingTop = 'top',
  } = props;

  const inverted = invertedThemes.includes(
    backgroundColor ? backgroundColor : ''
  );

  return (
    <div
      className={cn(styles.block, {
        [styles.inverted]: inverted,
        ...(individualSpacing
          ? {
              [styles[`spacingTop--${spacingTop}`]]: spacingTop,
              [styles[`spacingBottom--${spacingBottom}`]]: spacingBottom,
            }
          : {
              [styles[`spacing--${spacing}`]]: spacing,
            }),
      })}
      {...(backgroundColor &&
        backgroundColor !== 'none' && {
          'data-background-color': backgroundColor,
        })}
    >
      {props.children}
    </div>
  );
};
